<style lang="less" scoped>
div.wrapper {
  position: relative;

  div.dialog-wrapper {
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    width: 100%;
    height:100%;
    background:rgba(0,0,0,0.3);
    div.dialog-content {
      width: 300px;
      height: 214px;
      position: absolute;
      top:50%;
      left:50%;
      transform: translate(-50%,-50%);
    }
  }

  div.content {
    width: 100%;
    min-height: 100vh;
    background: #CAC2CE url("../../assets/images/promotion/bg.png") no-repeat;    
    div.top-nav {
      padding-top: 50px;
      div.back {
        background:url("../../assets/images/promotion/icon-back.png") no-repeat;
        width: 84px;
        height: 84px;
        background-size:100% 100%;
        margin:0 0 0 50px;
      }
    }

    div.content-inner {
      div.congras {
        width: 656px;
        height: 192px;
        background:url("../../assets/images/promotion/congras.png") no-repeat;
        background-size:100% 100%;
        padding:50px auto 0 auto;
        margin:0 auto;
        position: relative;
        z-index: 2;
      }

      div.real-content {
        background:url("../../assets/images/promotion/amount-bg.png") no-repeat;
        width: 670px;
        height: 770px;
        background-size:100% 100%;
        margin:-50px auto 0 auto;
        div.rc {
            padding-top: 150px;
          h1.rc-caption {
            color:#272840;
            font-size: 30px;
            text-align: center;
          }

          p.rc-content {
            color:#8D37ED;
            font-size: 80px;
            text-align: center;
            margin:30px 0;
          }

          div.img-intro {
            background:url("../../assets/images/promotion/intro-bg.png") no-repeat;
            background-size:100% 100%;
            width: 456px;
            height:40px;
            margin:0 auto;
            text-align: center;
            color:#fff;
            font-size: 24px;
            padding-top: 40px;
            margin-bottom: 50px;
          }

          div.btn-apply {
            background:url("../../assets/images/promotion/apply-bg.png") no-repeat;
            background-size:100% 100%;
            width: 542px;
            height: 124px;
            margin:0 auto;
          }
        }

        div.logo {
          display: flex;
          justify-content: start;
          align-items: center;
          padding-top: 80px;
          margin-left: 40px;
          img {
              display: block;
              width: 102px;
              height: 102px;
              margin-right: 20px;
          }
  
          span.logo-text {
              font-size: 28px;
              color: #333;
          }
      }
      }
    }
  }
}
</style>
<template>
    <div class="wrapper">
        <div class="dialog-wrapper" v-show="loading">
            <div class="dialog-content"><img src="../../assets/images/promotion/loading.gif" alt=""></div>
        </div>
        <div class="content">
            <div class="top-nav">
                <div class="back" @click="goBack"></div>
            </div>
            <div class="content-inner">
                <div class="congras"></div>
                <div class="real-content">
                    <div class="rc">
                        <h1 class="rc-caption">Available to apply</h1>
                        <p class="rc-content" v-text="`₹${currentValue}`"></p>
                        <div class="img-intro" v-text="`Minimum interest rate ${rate}%(day)`"></div>
                        <div class="btn-apply" @click="jumpTo"></div>
                    </div>
                    <div class="logo">
                        <img src="../../assets/images/logo.png" alt="">
                        <span class="logo-text">Credit Chakr</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default {
    setup () {
        const amount = ref("0")
        const rate = ref("0")
        const router = useRouter()  
        const loading = ref(true)  
        const intervalId = ref(0)
        const currentValue = ref(0)

        const  getRandomMultipleOf1000 = (min, max) => {            
            min = Math.ceil(min / 1000) * 1000;
            max = Math.floor(max / 1000) * 1000;
            
            const randomMultiple = Math.floor(Math.random() * ((max - min) / 1000 + 1)) * 1000 + min;
            return randomMultiple;
        }
        const startCounting = () => {
          if (intervalId.value) {
            clearInterval(intervalId.value);
          }

          const step = 3000; 
          let counter = 0; 

          intervalId.value = setInterval(() => {
            currentValue.value = step * counter;
            counter++;

            if (currentValue.value >= amount.value) {
              clearInterval(intervalId.value); 
              currentValue.value = amount.value;
            }
          }, 50); 
        }
        setTimeout(()=>{
            const localAmount = window.localStorage.getItem("localAmount")
            if(localAmount) {
                amount.value = localAmount
            } else {
                amount.value = getRandomMultipleOf1000(50000,70000)
                window.localStorage.setItem("localAmount", amount.value)
            }
             

            startCounting()
            rate.value = "0.6"
            loading.value = false
        },3000)
        const jumpTo = ()=>{
            router.replace({
                path:"/"
            })        
        }
        const goBack = () => {
            router.go(-1)
        }
        return {
            currentValue,
            loading,
            amount,
            rate,
            jumpTo,
            goBack
        }
    }
}
</script>